import { render, staticRenderFns } from "./TasteKinds.vue?vue&type=template&id=5a468047&"
import script from "./TasteKinds.vue?vue&type=script&lang=js&"
export * from "./TasteKinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports